import { MobileTitle } from "../components/Title"

export const Story = () => {
    return (
        <>
            <MobileTitle title='Histoire' />
            <div className='py-12 md:py-20 drop-shadow-md w-4/5 md:w-3/5 mx-auto text-center text-shadow-white text-pbnavy font-kiwi font-bold text-sm md:text-base '>
                <p>
                    <span className='text-pborange'>Ivoire</span>... Un monde composé d'une infinité de petites îles
                    diverses et variées, perdu au beau milieu d'une immense mer, dans lequel cohabitent des humains, des
                    Bestials, des démons mais aussi des créatures aux pouvoirs magiques ou maléfiques.
                </p>{' '}
                <img
                    className='my-12 white-drop-shadow cursor-pointer mx-auto'
                    src={`${process.env.PUBLIC_URL}/images/ss/ss-story-1.webp`}
                    alt={`screen shot of game system`}
                />{' '}
                <p>
                    <span className='text-pborange'>Marona</span> est une petite fille capable de voir l'âme des défunts
                    - les <span className='text-pborange'>fantômes</span>. Elle effectue ses tâches de{' '}
                    <span className='text-pborange'>Chroma</span> au quotidien pour répondre aux besoin des gens de son
                    entourage, aux côtés de son ami le fantôme <span className='text-pborange'>Ash</span>.
                </p>{' '}
                <p>
                    Six mois après la disparition de Sulphur, Marona poursuit paisiblement sa vie et son travail de
                    Chroma. Mais alors qu'elle rentre de mission, le drame survient : la flotte des bateaux fantômes des
                    <span className='text-pborange'> Naufrageurs</span> attaque le bateau sur lequel elle se trouve avec
                    Ash. Un mystérieux homme masqué s'empare d'une partie de ses pouvoirs... Ash n'hésite pas à
                    s'engouffrer dans le bateau ennemi pour protéger son amie, mais{' '}
                    <span className='text-pborange'>disparaît sans explication</span>…
                </p>{' '}
                <p>
                    Marona parvient de justesse à s'échapper des Naufrageurs et rencontre Abricot, une petite fille
                    fantôme à <span className='text-pborange'>la recherche de son père disparu</span>. Ce dernier se
                    révèle être Argento, <span className='text-pborange'>le commandant des Pirates d'Argento</span>, une
                    flotte de pirates au bord de l'extinction, faute de trouver un remplaçant digne de ce nom pour les
                    mener. Marona décide alors de s'unir avec Abricot pour le retrouver et
                    <span className='text-pborange'> reformer l'équipage des pirates</span> de son père.
                </p>{' '}
                <p>
                    À deux, elles prennent la décision de devenir des pirates et d'élargir leur territoire afin de
                    rendre à leur équipage ses lettres de noblesse.
                </p>{' '}
                <p>
                    C'est le début des aventures sur les mers d'Ivoire de Marona, la petite fille aux mystérieux
                    pouvoirs, ainsi que de tous <span className='text-pborange'>ses amis pirates et fantômes</span> !
                </p>
            </div>
        </>
    )
}
